interface PackagesIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const PackagesIcon = (props: PackagesIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  const style = {
    fill: 'none',
    stroke: fillColor,
    strokeLineCap: 'round',
    strokeLineJoin: 'round',
  }

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <polyline style={style} points="8.39 21.47 8.39 29.38 19.98 34.86 31.94 29.23 31.94 21.58" />
      <polyline
        style={style}
        points="19.98 34.86 19.98 19.41 9.06 14.7 5.37 9.77 16.31 5.14 19.98 9.81 23.78 5.14 34.63 9.68 31.94 14.21 19.98 19.41"
      />
      <line style={style} x1="11.31" y1="15.67" x2="20.04" y2="11.95" />
      <line style={style} x1="14.13" y1="16.89" x2="19.37" y2="14.64" />
      <line style={style} x1="16.48" y1="17.88" x2="19.33" y2="16.66" />
    </svg>
  )
}

export default PackagesIcon
